import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { FullScreenLoader } from "@/components/feedback/FullScreenLoader";

/**
 * Wraps protected routes. Waits for the initial auth resolution
 * (isLoading) before deciding — without this, a hard refresh on a
 * protected page would briefly see isAuthenticated=false and redirect to
 * /login even for an already-signed-in user, because Supabase's session
 * restore from storage is asynchronous.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <FullScreenLoader message="Checking your session…" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
